import axios from "../axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 * @param data
 * @returns {Function}
 */
export const setModule = data => {
  return dispatch => {
    dispatch({ type: "MODULE_SET", data });
  };
};

/**
 *
 * @param data
 * @returns {Function}
 */
export const enrollModule = data => {
  return async dispatch => {
    dispatch({ type: "MODULE_ENROLL", data });

    const url =
      AxiosConfig.getEndpointAddress() + "/modules/" + data.id + "/enroll";

    await axios
      .put(url, {}, AxiosConfig.getAuthConfig())
      .then(response => {
        dispatch({
          type: "MODULE_ENROLL_FULFILLED",
          data: response.data.data
        });
      })
      .catch(function(error) {
        dispatch({
          type: "MODULE_ENROLL_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param data
 * @returns {Function}
 */
export const unEnrollModule = data => {
  return async dispatch => {
    dispatch({ type: "MODULE_UNENROLL", data });

    const url =
      AxiosConfig.getEndpointAddress() + "/modules/" + data.id + "/unenroll";

    await axios
      .put(url, {}, AxiosConfig.getAuthConfig())
      .then(response => {
        dispatch({
          type: "MODULE_UNENROLL_FULFILLED",
          data: response.data.data
        });
      })
      .catch(function(error) {
        dispatch({
          type: "MODULE_UNENROLL_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param id
 * @returns {Function}
 */
export const fetchModule = id => {
  return dispatch => {
    dispatch({ type: "MODULE_FETCH" });

    const url = AxiosConfig.getEndpointAddress() + "/modules/" + id;

    axios
      .get(url, AxiosConfig.getAuthConfig())
      .then(response => {
        dispatch({
          type: "MODULE_FETCH_FULFILLED",
          data: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: "MODULE_FETCH_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param id
 * @returns {Function}
 */
export const startActivity = id => {
  return dispatch => {
    dispatch({ type: "ACTIVITY_START" });

    const url =
      AxiosConfig.getEndpointAddress() + "/activities/" + id + "/start";

    axios
      .put(url, {}, AxiosConfig.getAuthConfig())
      .then(response => {
        dispatch({
          type: "ACTIVITY_START_FULFILLED",
          data: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: "ACTIVITY_START_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param id
 * @returns {Function}
 */
export const completeActivity = id => {
  return dispatch => {
    dispatch({ type: "ACTIVITY_COMPLETE" });

    const url =
      AxiosConfig.getEndpointAddress() + "/activities/" + id + "/complete";

    axios
      .put(url, {}, AxiosConfig.getAuthConfig())
      .then(response => {
        dispatch({
          type: "ACTIVITY_COMPLETE_FULFILLED",
          data: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: "ACTIVITY_COMPLETE_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param id
 * @param score
 * @param answers
 * @returns {Function}
 */
export const scoreActivity = (id, score, answers) => {
  return async dispatch => {
    dispatch({ type: "ACTIVITY_SCORE" });

    const url =
      AxiosConfig.getEndpointAddress() + "/activities/" + id + "/score";

    await axios
      .post(
        url,
        {
          score,
          answers
        },
        AxiosConfig.getAuthConfig()
      )
      .then(response => {
        dispatch({
          type: "ACTIVITY_SCORE_FULFILLED",
          data: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: "ACTIVITY_SCORE_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param message
 * @returns {Function}
 */
export const askAnExpert = (id, message) => {
  return dispatch => {
    dispatch({ type: "ASK_EXPERT" });

    const url =
      AxiosConfig.getEndpointAddress() + "/modules/" + id + "/askanexpert";

    axios
      .post(
        url,
        {
          message
        },
        AxiosConfig.getAuthConfig()
      )
      .then(response => {
        dispatch({
          type: "ASK_EXPERT_FULFILLED",
          data: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: "ASK_EXPERT_REJECTED",
          data: error
        });
      });
  };
};

/**
 *
 * @param module
 * @returns {Function}
 */
export const certificatePDF = module => {
  return async dispatch => {
    dispatch({ type: "MODULE_CERTIFICATE_PDF", data: module });

    const url =
      AxiosConfig.getEndpointAddress() +
      "/modules/" +
      module.id +
      "/certificate";

    await axios
      .get(url, {
        ...AxiosConfig.getAuthConfig(),
        responseType: "blob"
      })
      .then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", module.name + ".pdf");
        document.body.appendChild(link);
        link.click();

        dispatch({ type: "MODULE_CERTIFICATE_PDF_FULFILLED" });
      })
      .catch(function(error) {
        dispatch({ type: "MODULE_CERTIFICATE_PDF_REJECTED", data: error });
      });
  };
};
